import React from 'react';
import { useLocation } from 'react-router';

import { useTranslation } from 'app/lang';
import { useMenuItemsByFeatureFlags } from 'app/lib/feature-flags/useMenuItemsByFeatureFlags';

import { RootMenu } from '../RootMenu';
import { serviceMenuItemsWithPathname } from '../selectors/service';

import dictionary from './ServiceMenuLayer.dictionary.json';

import styles from './ServiceMenuLayer.module.scss';

export const ServiceMenuLayer = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const filteredItems = useMenuItemsByFeatureFlags({ fn: serviceMenuItemsWithPathname, pathname });

  return (
    <>
      <div className={styles.header}
           data-test="layer-menu-header">
        {t(dictionary?.title) || ' '}
      </div>
      <RootMenu list={filteredItems} />
    </>
  );
};
